<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-gray"></i>
        WEB DUKA - Retail Management System
        <i class="fa fa-circle text-warning"></i>
      </h5>
      <b-row>
        <b-col lg="12">
          <Widget
            class="widget-registration mx-auto"
            title="<h3 class='mt-2'>Register here for a free account</h3>"
            customHeader
          >
            <br />
            <b-form @submit="register">
              <b-row class="form-row">
                <b-col lg="4" class="mr-auto">
                  <b-form-group label="First Name:" label-for="input-firstName">
                    <b-form-input
                      id="input-firstName"
                      v-model="person.firstName"
                      required
                      placeholder="Enter First Name"
                    />
                  </b-form-group>

                  <b-form-group label="Last Name:" label-for="input-lastName">
                    <b-form-input
                      id="input-lastName"
                      v-model="person.lastName"
                      required
                      placeholder="Enter Last Name"
                    />
                  </b-form-group>

                  <b-form-group label="Middle Name:" label-for="input-middleName">
                    <b-form-input
                      id="input-middleName"
                      v-model="person.middleName"
                      placeholder="Enter Middle Name"
                    />
                  </b-form-group>

                  <b-form-group id="input-group-dob" label="DOB:" label-for="input-dob">
                    <b-form-input
                      id="input-dob"
                      v-model="person.dob"
                      type="date"
                      required
                      placeholder="Enter DOB"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4" class="mr-auto">
                  <b-form-group label="Email:" label-for="input-email">
                    <b-form-input
                      id="input-email"
                      v-model="person.contact.email"
                      aria-required="true"
                      type="email"
                      required
                      placeholder="Enter Email"
                    />
                  </b-form-group>

                  <b-form-group label="Phone Number:" label-for="input-email">
                    <b-form-input
                      id="input-phoneNumber"
                      v-model="person.contact.phoneNumber"
                      type="tel"
                      placeholder="Enter Phone Number (For account recovery)"
                    />
                  </b-form-group>

                  <b-form-group label="New Password:" label-for="input-password">
                    <b-form-input
                      id="input-password"
                      v-model="person.password"
                      type="password"
                      required
                      placeholder="New password"
                    />
                  </b-form-group>

                  <b-form-group label="Repeat Password:" label-for="input-password">
                    <b-form-input
                      id="input-repeat_password"
                      v-model="repeat_password"
                      type="password"
                      required
                      placeholder="Repeat password"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4" class="mr-auto">
                  <b-form-group label="Shop Name:" label-for="input-shop-name">
                    <b-form-input
                      id="input-shop-name"
                      v-model="person.shop.name"
                      required
                      placeholder="Enter Shop Name"
                    />
                  </b-form-group>

                  <b-form-group label="Physical Location:" label-for="input-shop-physicalAddress">
                    <b-form-input
                      id="input-shop"
                      v-model="person.shop.physicalAddress"
                      required
                      placeholder="Physical Address"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    class="pull-right"
                    type="submit"
                    v-if="getValidRepeatPassword"
                    variant="primary"
                  >Register</b-button>
                </b-col>
              </b-row>
            </b-form>
            <div>
              <p class="widget-auth-info">
                <router-link
                  class="d-block text-center"
                  to="login"
                >Have an account? Go back to login</router-link>
              </p>
            </div>
          </Widget>
        </b-col>
      </b-row>
    </b-container>
    <footer class="auth-footer">2019 &copy; WebDuka Point of Sale and Retail Management System.</footer>

    <b-modal ref="error_modal" id="error_modal" title="Opps !">
      <p class="my-4">Error occured during save : {{ err_mesage }}</p>
    </b-modal>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import userApi from "@/services/userApi";

export default {
  name: "Register",
  components: { Widget },
  data() {
    return {
      repeat_password: "",
      person: {
        firstName: "",
        middleName: "",
        lastName: "",
        dob: null,
        contact: {
          email: "",
          phoneNumber: ""
        },
        userName: "",
        password: "",
        shop: {}
      },
      err_mesage: "",
      genders: [{ text: "Select One", value: "" }],
      show: true
    };
  },
  methods: {
    onSaved(sucessful, error_msg) {
      if (sucessful) {
        // login and redirect to dashboard
        this.$router.push("/login");
      } else {
        this.err_mesage = error_msg;
        this.$refs["error_modal"].show();
      }
    },
    register(evt) {
      evt.preventDefault();
      this.person.userName = this.person.contact.email;
      userApi
        .register(this.person)
        .then(response => {
          this.person = response;
          this.onSaved(true, "");
        })
        .catch(error => {
          this.onSaved(false, error);
        });
    }
  },
  computed: {
    getValidRepeatPassword() {
      return this.person.password === this.repeat_password;
    }
  },
  created() {
    if (window.localStorage.getItem("authenticated") === "true") {
      this.$router.push("/app/main/analytics");
    }
  }
};
</script>